export const tipForDevelopmentCategoryMap = {
    none: 0,
    firstTimeFixFailure: 1,
    longRepair: 2,
    abnormalPreventiveMaintenance: 3,
    manHoursHigh: 4,
} as const;

export type TipForDevelopmentCategory = keyof typeof tipForDevelopmentCategoryMap;

const tipForDevelopmentDefinition = {
    none: { id: 0, name: "None", color: "#4D33DC" },
    partMissing: { id: 1, name: "Part missing", color: "#FD3535" },
    knowledgeIssue: { id: 2, name: "Knowledge issue", color: "#4B244A" },
    planningIssue: { id: 3, name: "Planning issue", color: "#0099BB" },
    wrongRegistration: { id: 4, name: "Wrong registration", color: "#FF7921" },
    customerDisagreesOnRepair: { id: 5, name: "Customer disagrees on repair", color: "#73BD07" },
    customerBehaviour: { id: 6, name: "Customer behaviour", color: "#850C18" },
    partQualityIssue: { id: 7, name: "Part quality issue", color: "#FFC700" },
    unrelatedIssue: { id: 8, name: "Unrelated issue", color: "#ffb584" },
    alarmDescriptionIssue: { id: 9, name: "Alarm description issue", color: "#80cae3" },
    routineCostsUnreasonableEffort: { id: 10, name: "Routine costs unreasonable effort", color: "#ebebeb" },
    riskCostAnalysisPreventsPartSwap: {
        id: 11,
        name: "Risk-cost analysis prevents part swap (intermittent fault)",
        color: "#fabb00",
    },
    remoteSupportPreferred: { id: 12, name: "Remote support preferred", color: "#44a12b" },
    notUrgentEnough: { id: 13, name: "Not urgent enough", color: "#FD3535" },
    manHoursHighJustified: { id: 14, name: "Man Hours High justified", color: "#4B244A" },
} as const;

export const getTipForDevelopmentById = (id: number) => {
    return Object.values(tipForDevelopmentDefinition).find((tip) => tip.id === id) ?? null;
};

export const tipsForDevelopment = Object.values(tipForDevelopmentDefinition).map(
    (tip) => tip.name,
) as ReadonlyArray<string>;

type TipForDevelopment = (typeof tipForDevelopmentDefinition)[keyof typeof tipForDevelopmentDefinition];

export const tipsForDevelopmentByCategory: Record<TipForDevelopmentCategory, TipForDevelopment[]> = {
    none: [],
    firstTimeFixFailure: [
        tipForDevelopmentDefinition.none,
        tipForDevelopmentDefinition.partMissing,
        tipForDevelopmentDefinition.knowledgeIssue,
        tipForDevelopmentDefinition.planningIssue,
        tipForDevelopmentDefinition.wrongRegistration,
        tipForDevelopmentDefinition.customerDisagreesOnRepair,
        tipForDevelopmentDefinition.customerBehaviour,
        tipForDevelopmentDefinition.partQualityIssue,
        tipForDevelopmentDefinition.unrelatedIssue,
        tipForDevelopmentDefinition.alarmDescriptionIssue,
    ],
    longRepair: [
        tipForDevelopmentDefinition.none,
        tipForDevelopmentDefinition.partMissing,
        tipForDevelopmentDefinition.knowledgeIssue,
        tipForDevelopmentDefinition.planningIssue,
        tipForDevelopmentDefinition.wrongRegistration,
        tipForDevelopmentDefinition.customerDisagreesOnRepair,
        tipForDevelopmentDefinition.customerBehaviour,
        tipForDevelopmentDefinition.partQualityIssue,
        tipForDevelopmentDefinition.unrelatedIssue,
        tipForDevelopmentDefinition.alarmDescriptionIssue,
    ],
    abnormalPreventiveMaintenance: [
        tipForDevelopmentDefinition.none,
        tipForDevelopmentDefinition.partMissing,
        tipForDevelopmentDefinition.knowledgeIssue,
        tipForDevelopmentDefinition.planningIssue,
        tipForDevelopmentDefinition.wrongRegistration,
        tipForDevelopmentDefinition.customerDisagreesOnRepair,
        tipForDevelopmentDefinition.customerBehaviour,
        tipForDevelopmentDefinition.partQualityIssue,
        tipForDevelopmentDefinition.unrelatedIssue,
        tipForDevelopmentDefinition.alarmDescriptionIssue,
    ],
    manHoursHigh: [
        tipForDevelopmentDefinition.none,
        tipForDevelopmentDefinition.wrongRegistration,
        tipForDevelopmentDefinition.remoteSupportPreferred,
        tipForDevelopmentDefinition.notUrgentEnough,
        tipForDevelopmentDefinition.manHoursHighJustified,
    ],
} as const;

export type TipForDevelopmentName = (typeof tipsForDevelopment)[number];
